<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BWBoOh/tc-custom/9780230339880.jpg?1731180728712" alt="This image is the cover for the book Cradle of Gold"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cradle of Gold
      </h1>
      <p class="bookDescription body article font2">
        <p>In 1911, a young Peruvian boy led an American explorer and Yale historian named Hiram Bingham into the ancient Incan citadel of Machu Picchu. Hidden amidst the breathtaking heights of the Andes, this settlement of temples, tombs and palaces was the Incas' greatest achievement. Tall, handsome, and sure of his destiny, Bingham believed that Machu Picchu was the Incas' final refuge, where they fled the Spanish Conquistadors. Bingham made Machu Picchu famous, and his dispatches from the jungle cast him as the swashbuckling hero romanticized today as a true Indiana Jones-like character. But his excavation of the site raised old specters of conquest and plunder, and met with an indigenous nationalism that changed the course of Peruvian history. Though Bingham successfully realized his dream of bringing Machu Picchu's treasure of skulls, bones and artifacts back to the United States, conflict between Yale and Peru persists through the present day over a simple question: Who owns Inca history?<br/><br/>In this grand, sweeping narrative, Christopher Heaney takes the reader into the heart of Peru's past to relive the dramatic story of the final years of the Incan empire, the exhilarating recovery of their final cities and the thought-provoking fight over their future. Drawing on original research in untapped archives, Heaney vividly portrays both a stunning landscape and the complex history of a fascinating region that continues to inspire awe and controversy today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christopher Heaney
      </h2>
      
      <p class="authorDescription body article"><P><B>Christopher Heaney </B>worked as a journalist in Peru on a Fulbright fellowship. He has written articles on Hiram Bingham for the <I>New</I><I> Republic</I> and <I>The New York Times</I>. A graduate of Yale University, he is currently a doctoral candidate in Latin American History at the University of Texas, Austin.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?56143898